import { formatDate } from '@angular/common';
import { Component, EventEmitter, PLATFORM_ID, NgZone, OnInit, Output, Inject, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormErrorService } from 'src/app/shared/form-validation/form-error.service';
import { RegexService } from 'src/app/shared/form-validation/regex.service';
import { ThankuResponse } from 'src/app/shared/payload-Model/billingFormModel';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { secureStorage } from 'src/app/shared/services/encryption/secureservice';
import { PaymentService } from 'src/app/shared/services/razorpaypayment/payment.service';
import { RootService } from 'src/app/shared/services/root.service';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { environment } from '../../../../environments/environment';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/shared/services/common.service';
import * as unbxUrl from '../../../../assets/unbx-script';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
declare const gtag: Function;
declare var $: any;
@Component({
  selector: 'app-general-booking',
  templateUrl: './general-booking.component.html',
  styleUrls: ['./general-booking.component.scss']
})
export class GeneralBookingComponent implements OnInit {
  @ViewChild("vasRPay", { read: TemplateRef }) vasRPay!: TemplateRef<any>;
  @ViewChild('modalOverlay') modalOverlay!: ElementRef;
  @Output() dealerData = new EventEmitter<{ dealerDataList: any }>();
  VasData: any
  kycKarzaRes: any;
  environment1 = environment.s3bucket.url;
  productId: any;
  productDetailList: any;
  isPanVerified: boolean = false;
  isAdhaarVerified: boolean = false;
  stateList: any = [];
  lobName: any;
  dealerList: any;
  step: any;
  finance: boolean = true;
  divData: any = [];
  dseList: any[];
  EddData: any;
  translatedFirstName: any;
  translatedLastName: any;
  translatedAddress1: any;
  translatedAddress2: any;
  userData: any;
  statedata: any;
  payMessage: string = "";
  isVerifyOtp: boolean = false;
  isconfirm: boolean = false;
  isProcess: boolean = true;
  otpInputValue: string = "";
  imageUrl: string = "";
  transactionComplete: boolean = false;
  transactionSuccess: boolean = false;
  transactionfailed: boolean = false;
  paymentSuccess: any;
  leadInfo: any;
  quantity: any;
  showPaymentOption: boolean = false;
  disableProceed: boolean = false;
  sub: Subscription = new Subscription();
  districtList: any;
  bookingForm!: FormGroup;
  bookingDescriptionForm!: FormGroup;
  dseMatch: boolean = false;
  dse: any[];
  dseLoaded: boolean = false;
  closeResult: string;
  isDisabled: boolean = false;
  errormessage:any
  panTypeOptions = [
    { label: 'Individual', value: 'Individual' }
    // { label: 'Company (including Partnership, Trust, Society, School, Hospital etc.)', value: 'Company' }
  ];
  fullNamedata: string;
  ispanData: any;

  @Output() quantityChange = new EventEmitter<{ quantity: any, totalAmount: any }>();
  @Output() VCPriceChange = new EventEmitter<{ newVCPrice: any }>();
  newVCPrice: any;
  responseData: any;
  fianceList = [
    { id: "1-39ERX-457", name: "AXIS BANK LTD" },
    { id: "1-28A6L98", name: "CHOLAMANDALAM DBS FINANCE LTD." },
    { id: "1-4G25N97", name: "CHOLAMANDALAM INVESTMENT AND FINANCE COMPANY LIMITED (CHENNAI)" },
    { id: "1-4GNWJ7P", name: "CHOLAMANDALAM INVESTMENT AND FINANCE COMPANY LIMITED. (VISAKHAPATNAM)" },
    { id: "1-5KQO5J7", name: "HDB FINANCIAL SERVICES LTD" },
    { id: "1-42W8M00", name: "HDB FINANCIAL SERVICES LIMITED" },
    { id: "1-39EXR-23303", name: "HDFC BANK" },
    { id: "1-4B9LIPD", name: "HDFC BANK LTD (SILIGURI)" },
    { id: "1-6HYPVYT", name: "HDFC BANK LTD (BHUJ)" },
    { id: "1-39ERX-1996", name: "HDFC BANK LTD (BACKBAY RECLAMATION)" },
    { id: "1-6HDJYVE", name: "INDUSIND BANK LIMITED" },
    { id: "1-39ERX-2289", name: "KOTAK MAHINDRA BANK LTD" },
    { id: "1-6HDJYVU", name: "MAHINDRA & MAHINDRA FINANCIAL SERVICES LTD (ANUPPUR)" },
    { id: "1-6LSQ7FN", name: "MAHINDRA & MAHINDRA FINANCIAL SERVICES LTD (JASHPUR)" },
    { id: "1-39ERX-14", name: "MAHINDRA & MAHINDRA FINANCIAL SERVICES LTD (APOLLO BUNDER)" },
    { id: "1-6RJIVJB", name: "TATA MOTORS FINANCE LIMITED" },
    { id: "1-39ERX-1572", name: "YES BANK LTD" },
    { id: "SELF", name: "SELF" },
  ];

  isSubmitForm: boolean = false;
  userKYCDetails: any;
  totalAmount: any;
  dealerCode: any;
  divisionList: any;
  dealerLen: any = 0;
  pagetitle = "OSP Booking";
  stock: number = 0;
  isVasAvailable: any = false;
  isViaConfigurator: any = false;
  leadData: any = [];
  typeOfBooking: string;
  state: any;
  dealerDataNotFound: boolean = false;
  loadAPI: Promise<any>;
  vc: any;
  showModal: boolean = false;
  displayAmt: any;
  ccavenue: any;
  VasDataFromProfile: any;
  utmdata: any;
  newVCPriceChange: any;
  dealername: any;
  removeCRM: boolean = false;
  downpayment: void;
  productOfferData: any = [];
  isAdhaarNoAvailable: any;
  isSmart: boolean = false;
  private clickSubject = new Subject<void>();
  private readonly debounceTimeInMillis = 300;
  btndisable: boolean = false;
  encryptAdharNO: string;
  schemeDealeCodes = ['1009590','1009460', '1001850','100B780','1007960','1009061','1001770','1009050','1009000','1000480','1008870', '1002600','100B710','100A150','1004850','100B540','1003530']
  row_idfnijourney: string;
  payment_data:any = [];
  isfnijourney :boolean = false;
  constructor(
    private apiService: ApiService, @Inject(PLATFORM_ID) private platformId: Object,
    private formErrorService: FormErrorService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private behaviourSubject: BehaviourSubjectService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService, private formBuilder: FormBuilder,
    private cleverService: ClevertapService,
    private router: Router, private winRef: PaymentService,
    private localStorage: secureStorage,
    private rootService: RootService, private ngZone: NgZone,
    private regexService: RegexService,
    private CommonService: CommonService,
  ) {
    this.clickSubject.pipe(debounceTime(this.debounceTimeInMillis),
      distinctUntilChanged(),
    )
    this.loadAPI = new Promise((resolve) => {
      this.regexService.loadScript();
      resolve(true);
    });
  }

  ngOnInit(): void {
    this.behaviourSubject.isSmart.subscribe((res) => {
      if (res) {
        this.isSmart = res;
      }
      else {
        this.isSmart = false;
      }
    })
    this.productOfferData = JSON.parse(this.localStorage.getItem("productOfferData"))
    this.getEncryptionccavenue();
    this.sub.add(this.activatedRoute.queryParams.subscribe((params) => {
      if (params['dealer']) {
        if (isPlatformBrowser(this.platformId)) {
          localStorage.setItem("dealercd", params['dealer']);
          localStorage.setItem("vc", params['vc']);
          this.vc = params['vc']
          this.dealerCode = localStorage.getItem("dealercd");
        }
      }
    }));
    if (localStorage.getItem("dealercd")) {
      this.isDisabled = true;
    }
    else{
      this.isDisabled=false;
    }
    this.activatedRoute.paramMap.subscribe(params => {
      this.typeOfBooking = params.get('type');
    });
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView(this.pagetitle);
      } catch { }
    }
    this.VasData = this.localStorage.getItem("VASData") ? JSON.parse(this.localStorage.getItem("VASData")) : null;
    if (this.typeOfBooking == 'Finance') {
      this.VasData = this.localStorage.getItem("VASDataProfile") ? JSON.parse(this.localStorage.getItem("VASDataProfile")) : null;
    }
    else {
      this.VasData = this.localStorage.getItem("VASData") ? JSON.parse(this.localStorage.getItem("VASData")) : null;

    }

    this.isVasAvailable = this.VasData?.VasAvailable == 'YES' ? true : false;
    this.isViaConfigurator = this.VasData?.isViaConfigurator;

    this.bookForm(null);
    this.dealerCode = localStorage.getItem("dealercd");
    // this.dealerCode= "";
    // this.dealerCode ="1001680"
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.productId = params.get('id')
        this.row_idfnijourney = params.get('row_id');
      }
    })
    if (this.row_idfnijourney) {
      this.isfnijourney = true;
      this.getPaymentData(this.row_idfnijourney)
    }
    else{
      this.isfnijourney = false;
    }
    this.getVehicleDetail();
    this.leadData = [];
    this.utmdata = [];
    this.leadData = JSON.parse(this.localStorage.getItem("retryPaymentData"));

    this.utmdata = JSON.parse(this.localStorage.getItem('myObject'));

  }


  getEncryptionccavenue() {
    let req = {
      "type": "ccavenue",
      "filter": environment.ccavenueType
    }
    try {
      this.sub.add(this.apiService.getCCEncDetail(req).subscribe({
        next: (res: any) => {

          if (res.success) {
            if (isPlatformBrowser(this.platformId)) {

              let decrypt = this.localStorage.decryptData(res.data);
              this.ccavenue = JSON.parse(decrypt.replaceAll(`'`, `"`));
            }
          }
        },
        error: () => {
        },
        complete: () => {
        }
      }))
    } catch (error) {
    }

  }


  finanacialApproval(val: boolean) {
    this.finance = val;
    if (!val) {
      //  let a = this.bookingForm.value.haveFinancialApproval;
      //   a.clearValidators();
      //   let b =this.bookingForm.value.haveFinancialApproval;
      //   b.updateValueAndValidity();
      this.bookingForm.controls['financeDrp'].clearValidators();
      this.bookingForm.controls['financeDrp'].updateValueAndValidity();

    }
    else {
      this.bookingForm.controls["financeDrp"].setValidators([Validators.required]);
      this.bookingForm.controls["financeDrp"].updateValueAndValidity();
    }
  }

  // onFocusOutRemoveSpaceFirstName(event: any) {
  //   let value = (event.target.value).replace(/\s/g, "")
  //   this.bookingForm.patchValue({ first_name: value })
  // }
  // onFocusOutRemoveSpace(event: any) {
  //   let value = (event.target.value).replace(/\s/g, "")
  //   this.bookingForm.patchValue({ last_name: value })
  // }
  getUserDetails() {
    let res = this.rootService.isLoggedIn();
    if (res) {
      this.sub.add(this.apiService.getUserData().subscribe({
        next: (response: any) => {
          this.rootService.setUser(response["data"]);
          this.rootService.setUserId(response["data"]);
          this.userData = [];
          this.userData = response["data"];
          const firstName = this.CommonService.replaceUnicode(this.userData.first_name) || '';
            const lastName = this.CommonService.replaceUnicode(this.userData.last_name) == '.' ? '' : this.CommonService.replaceUnicode(this.userData.last_name) || '';
            this.fullNamedata = `${firstName}${lastName}`.trim();
          this.getLoyalitySignup();
          this.userKYCDetails = response["data"];


          if (this.userKYCDetails?.user_documents) {
            for (let i = 0; i < this.userKYCDetails.user_documents?.length; i++) {
              if (this.userKYCDetails.user_documents[i].document_description == "aadhar_card") {
                this.isAdhaarNoAvailable = this.userKYCDetails.user_documents[i].doc_number
                this.bookingForm.controls['aadhar'].setValue(this.isAdhaarNoAvailable);
                this.bookingForm.get("aadhar").updateValueAndValidity();
                // this.selectedAddressProof = this.userKYCDetails.user_documents[i].document_description
                // this.selectedAddDocNo = this.userKYCDetails.user_documents[i].doc_number
                this.isAdhaarVerified = this.userKYCDetails.user_documents[i].e_kyc
              }
              else {
                let panNo = this.userKYCDetails.user_documents[i].doc_number;
                this.bookingForm.controls['panNo'].setValue(panNo);
                this.bookingForm.get("panNo").updateValueAndValidity();
                // this.selectedIDProof = this.userKYCDetails.user_documents[i].document_description
                // this.selectedIdDocNo = this.userKYCDetails.user_documents[i].doc_number
                this.isPanVerified = this.userKYCDetails.user_documents[i].e_kyc
              }
            }
          }
          if (this.typeOfBooking == 'Finance') {
            this.bookForm(this.leadData);

          }
          else {
            this.bookForm(this.userData);
          }
        }
      })
      );
    } else {
      this.toastrService.warning('Kindly Login');

      this.router.navigate(['/login/']);
    }
  }

  checkDSE(event: any) {
    this.dse = [];
    this.dseLoaded = false;

    if (this.bookingForm.value.dse && this.dseList?.length > 0) {
      this.dseMatch = false;
      this.dseLoaded = false;

      this.dse = [];

      this.dseList.forEach((element) => {
        if ((element.username)?.toLowerCase() == (this.bookingForm.value.dse)?.toLowerCase()) {
          this.dseMatch = true;
          this.dse = element;
          this.dseLoaded = true;

        }
      });
      if (!this.dseMatch) {
        this.dseLoaded = true;

        // this.toastrService.error("Provided CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin does not match with the dealer.");

      }
    }

    event.stopPropagation();
    event.preventDefault();
  }
  checkKYC() {

    if (this.bookingForm.controls["panNo"].value.Invalid) {
      this.toastrService.warning('Invalid format of Pan Number')
    }
    else if (this.bookingForm.controls["aadhar"].value.Invalid) {
      this.toastrService.warning('Invalid format of Adhaar Card Number')

    }

    var kfcJson = {
      "pan": this.bookingForm.controls["panNo"].value,
      "aadhaarLastFour": this.bookingForm.controls["aadhar"].value.substr(this.bookingForm.controls["aadhar"].value?.length - 4),
      "dob": "",
      "name": "",
      "address": "",
      "getContactDetails": "N",
      "PANStatus": "Y",
      "isSalaried": "N",
      "isDirector": "N",
      "isSoleProp": "N",
      "fathersName": "N",
      "consent": "Y",
      "clientData": {
        "caseId": "123456"
      }
    }
    this.spinner.show()
    try {

      this.sub.add(this.apiService.checkkyc(kfcJson).subscribe({
        next: (res: any) => {
          if (res.success) {
            if (res.data.result) {
              this.kycKarzaRes = res.data.result;
              if(this.bookingForm.value.pan_type === 'Individual'){               
                this.bookingForm.controls['first_name'].setValue(res.data.result.firstName);
                this.bookingForm.controls['last_name'].setValue(res.data.result.lastName);
              } else{  
                this.bookingForm.controls['full_name'].setValue(res.data.result.name);
              }
              if (Object.keys(res.data.result).length !== 0) {
                if (res.data.result?.aadhaarMatch == true) {

                  if (((this.bookingForm.controls['first_name'].value.trim()).toLowerCase() === res.data.result?.firstName.toLowerCase()) && this.bookingForm.value.pan_type === 'Individual') {
                    if (!this.isAdhaarVerified || !this.isPanVerified ) {

                      this.uploadKyc()
                    }
                    this.toastrService.success("KYC Done Successfully")
                  }
                  else {
                    this.spinner.hide()
                    this.toastrService.warning("Name Not Matching With Pan Card")
                    return
                  }
                } else  if (res.data.result?.aadhaarMatch == null) {
                  if(((this.bookingForm.controls['full_name'].value.trim()).toLowerCase() === res.data.result?.name.toLowerCase()) && this.bookingForm.value.pan_type === 'Company') {
                  if (!this.isPanVerified ) {

                    this.uploadKyc()
                  }
                  else{
                    this.spinner.hide()
                    this.toastrService.warning("Name Not Matching With Pan Card")
                    return
                  }
                }
                }
                else {
                  this.spinner.hide()
                  this.toastrService.warning("Aadhaar number is incorrect.")
                  return
                }
              }
              else {
                this.spinner.hide()
                this.toastrService.warning("Aadhaar number or PAN number is incorrect.")
                return
              }
            }
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
        },
        error: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  uploadKyc() {
    let req;
    if (!this.isAdhaarVerified && this.isPanVerified && this.bookingForm.value.pan_type === 'Individual') {
      req = {
        "address_proofs": [
          {
            "data": "",
            "document_type": "Address Proof",
            "document_description": "aadhar_card",
            "doc_number": this.bookingForm.controls["aadhar"].value,
            "e-KYC": true
          }
        ]
      }
    }
    else if (!this.isPanVerified && this.isAdhaarVerified && this.bookingForm.value.pan_type === 'Individual') {
      req = {
        "id_proofs": [
          {
            "data": "",
            "document_type": "ID Proof",
            "document_description": "id_pancard",
            "doc_number": this.bookingForm.controls["panNo"].value,
            "e-KYC": true
          }
        ]
      }
    } else  if (!this.isPanVerified && !this.isAdhaarVerified && this.bookingForm.value.pan_type === 'Individual') {
      req = {
        "address_proofs": [
          {
            "data": "",
            "document_type": "Address Proof",
            "document_description": "aadhar_card",
            "doc_number": this.bookingForm.controls["aadhar"].value,
            "e-KYC": true
          }
        ],
        "id_proofs": [
          {
            "data": "",
            "document_type": "ID Proof",
            "document_description": "id_pancard",
            "doc_number": this.bookingForm.controls["panNo"].value,
            "e-KYC": true
          }
        ]
      }
    }
    else{
      req = {
        "id_proofs": [
          {
            "data": "",
            "document_type": "ID Proof",
            "document_description": "id_pancard",
            "doc_number": this.bookingForm.controls["panNo"].value,
            "e-KYC": true
          }
        ]
      }
    }
    try {
      this.sub.add(this.apiService.uploadKYC(req).subscribe({
        next: (res: any) => {
          if (res.success) {
            this.updateUserAddress()
          }
          else {
            this.spinner.hide()
            this.toastrService.warning(res.data.msg)
          }
          // this.isShowThankyouPage = true
        },
        error: () => {
          this.spinner.hide()
        },
        complete: () => {
          this.spinner.hide()
        }
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  updateUserAddress() {
    let karzaRes = this.kycKarzaRes?.address
    var userAddrss = karzaRes ? karzaRes.buildingName + ',' + karzaRes.streetName + ',' + karzaRes.locality : this.CommonService.replaceUnicode(this.userData?.address_one)
    let data = {
      "id": this.userData.id,
      "first_name":this.bookingForm.value.pan_type === 'Individual'? this.CommonService.replaceUnicode(this.bookingForm.controls['first_name'].value.trim()) : this.CommonService.replaceUnicode(this.bookingForm.controls['full_name'].value.trim()),
      "last_name": this.bookingForm.value.pan_type === 'Individual' ? this.CommonService.replaceUnicode(this.bookingForm.controls['last_name'].value.trim()) : '.',
      "email_id": this.bookingForm.controls['email_id'].value.trim(),
      "address_one": this.CommonService.replaceUnicode(userAddrss),
      "account_type":this.bookingForm.value.pan_type ? this.bookingForm.value.pan_type : ''
      //  + ',' +  userAddrss.city + '-' + userAddrss.pinCode + ',' + userAddrss.state + ',' + userAddrss.country ,
    }
    try {
      this.sub.add(this.apiService.updateCustomer(data).subscribe({
        next: (res: any) => {
          if (res.success) {
            // this.toastrService.success(res.data.msg);
            this.getUserDetails()
            this.spinner.hide()
          }
          else {
            this.toastrService.warning(res.data.msg)
            this.spinner.hide()

          }
        },
        error: () => {
          this.spinner.hide()
        },
      }))
    } catch (error) {
      this.spinner.hide();
    }
  }
  bookForm(userData?: any) {
    let statecodes;
    let statedata = [];
    let districtData;
    if (userData) {

      statedata = this.stateList.filter(
        (result) => result.name === userData?.state
      );

      // let statedata = state.split(",");
      if (statedata?.length > 0) {

        statecodes = statedata[0].code;

        this.getDistrictList(statedata);
        // statedata = this.districtList.filter(
        //   (result) => result.name === userData?.district?.toLowerCase()
        // );
        districtData = userData?.district?.toLowerCase()
      }
      if (statedata?.length == 0) {

        statecodes = "";
        districtData = "";
      }
    }
    let adhaarNo;
    let panNo;
    if (this.userData?.user_documents) {
      for (let i = 0; i < this.userData.user_documents?.length; i++) {
        if (this.userData.user_documents[i].document_description == "aadhar_card") {
          this.isAdhaarNoAvailable = this.userData.user_documents[i].doc_number == ' ' ? this.userData.user_documents[i].doc_number.replace(/\s/g, '') : this.userData.user_documents[i].doc_number;
          this.bookingForm.controls['aadhar'].setValue(this.isAdhaarNoAvailable);
          this.bookingForm.get("aadhar").updateValueAndValidity();
          this.isAdhaarVerified = this.userData.user_documents[i].e_kyc
        }
        else {
          panNo = this.userData.user_documents[i].doc_number;
          this.bookingForm.controls['panNo'].setValue(panNo);
          this.bookingForm.get("panNo").updateValueAndValidity();
          this.isPanVerified = this.userData.user_documents[i].e_kyc
        }
      }
    }
    let newuserData = userData ? userData : this.userData;
    this.bookingForm = this.formBuilder.group({
      address1: [newuserData ? (newuserData?.address_one)?.substring(0, 59) ?
        (newuserData.address_one).substring(0, 59) : "" : ""],
      address2: [newuserData ? (newuserData.address_two)?.substring(0, 59) ?
        (newuserData.address_two)?.substring(0, 59) : "" : ""],
      first_name: [this.userData ? this.userData?.first_name : "",
      [Validators.required]],
      last_name: [this.userData ? this.userData?.last_name === '.' ? '' : this.userData?.last_name : ""],
      email_id: [newuserData ? newuserData.email_id ? newuserData.email_id : "" : "",
      [Validators.pattern(this.regexService.Email)]],
      bookingpermission: ["no"],
      bookinguseramount: [null],
      state: [statecodes, [Validators.required]],
      district: [districtData, [Validators.required]],
      city: [""],
      dealer: ["", [Validators.required]],
      // quantity: [this.typeOfBooking && userData ? userData.quantity ? userData.quantity : "" : "",
      // [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)]],
      // quantity:1,
      quantity: ["1", [Validators.required, Validators.maxLength(2), Validators.min(1), Validators.max(10)],],
      annulMaintenance: ["no"],
      haveFinancialApproval: ["yes"],
      leasingInterest: ["no"],
      financeDrp: [""],
      paymentType: [""],
      dse: [this.typeOfBooking && userData ? userData.dse_username ? userData.dse_username : "" : ""],
      panNo: [
        this.userData ? (panNo ? panNo : "") : "", // Set initial value
        this.isVasAvailable 
          ? [Validators.required, Validators.pattern(this.regexService.Pan), this.hasPatterncheckError()] 
          : [Validators.pattern(this.regexService.Pan),this.hasPatterncheckError()] // Ensure custom validator is always applied
      ],
      aadhar: [
        this.userData && this.isAdhaarNoAvailable ? this.isAdhaarNoAvailable : '',
        (this.isVasAvailable && this.userData?.account_type === 'Individual')
          ? [Validators.required, Validators.pattern(this.regexService.Aadhar)]
          : [Validators.pattern(this.regexService.Aadhar)]
      ],
      pan_type: ['Individual', Validators.required],
        full_name: [ this.fullNamedata],
    });
    this.bookingForm.get('pan_type')?.valueChanges.subscribe(value => {
      this.updateFirstNameValidation(value);
    });
    if (this.dealerCode && this.dealerLen > 0) {
      this.bookingForm.patchValue({ "state": this.stateList[0]?.code });
    }
    if (this.isVasAvailable) {
      this.bookingForm.patchValue({ "annulMaintenance": 'yes' });
    }

    // this.bookingDescriptionForm = this.formBuilder.group({
    //   typeOfBussiness: ["", [Validators.required]],
    //   natureOfBussiness: ["", [Validators.required]],
    //   yearsInBussiness: ["", [Validators.required]],
    //   gstNo: ["", [Validators.pattern(this.regexService.GstNo)]],
    // });
  }
  getPanType(): string {
    let pandata = this.ispanData 
    
    if (pandata && pandata.length === 10) {
      return pandata[3] === 'P' ? 'Individual' : this.userData?.account_type;
    } 
    
    return this.userData?.account_type || ''; // Default to userData's account_type if available
  }
  getVehicleDetail() {

    let data
    if (this.vc) {
      data = {
        vehicle_number: this.vc
      }
    }
    else {


      data = {
        product_id: this.productId
      }
    }
    this.sub.add(this.apiService.getVehicleDetails(data).subscribe({
      next: (res: any) => {
        this.productDetailList = res?.data;
        this.downpayment = this.productDetailList.down_payment
        this.imageUrl = this.productDetailList?.images[0]?.image_url
        this.getStateList(this.productDetailList?.lob);
        this.productAddedtoCart();
        if (this.VasData && (this.VasData.VCNUMBER !== this.productDetailList.vehicle_number)) {
          localStorage.removeItem('VASData');
          this.behaviourSubject.vasCreated.next(true);
        }
        // if (this.productOfferData && (this.productOfferData?.vehicle_number !== this.productDetailList?.vehicle_number)) {

        //   localStorage.removeItem("productOfferData")
        //       }
        this.totalAmount = this.productDetailList["down_payment"] ? this.productDetailList["down_payment"] : 0;
        if (this.typeOfBooking) {

          this.quantityChange.emit({ quantity: this.leadData ? this.leadData.quantity : 1, totalAmount: this.leadData.payment_info.amount });

        }
        else {
          if(this.isfnijourney && this.payment_data?.length > 0){
            this.totalAmount = this.payment_data[0]?.amount;
          }else
          {
          this.totalAmount = this.productDetailList["down_payment"] ? this.productDetailList["down_payment"] : 0;
        }
          this.quantityChange.emit({ quantity: this.bookingForm.controls['quantity'].value ? this.bookingForm.controls['quantity'].value : 1, totalAmount: this.totalAmount });
        }
        this.lobName = this.productDetailList?.lob;
        if (this.dealerCode) {
          this.getDealer();
        }
        //   else{
        // this.getStateList(this.productDetailList.lob);
        //   }
        // this.pplName=this.productDetailList?.ppl
        // this.plName=this.productDetailList?.pl
        // this.productPrice=this.productDetailList?.price_range
        // this.isUpdatedValue = true
      },
      error: () => { },
      complete: () => { }
    }))
  }
  // AnaplanCVEnquiryMTO.json
  getEddData() {
    try {
      this.sub.add(this.apiService.getS3Data('Anaplan/AnaplanCVEnquiryMTO.json')
        .subscribe({
          next: (res: any) => {
            this.EddData = res.data
          },
          error: () => {
          },
          complete: () => { }

        })
      )
    } catch (error) {
    }

  }
  getVCPrice(data) {

    this.sub.add(this.apiService.getDealerPrice(data).subscribe({
      next: (response: any) => {
        this.VCPriceChange.emit({ newVCPrice: response?.data?.dealer_price ? response.data.dealer_price : null });
        this.newVCPriceChange = response?.data?.dealer_price;
      },
      error: () => { },
      complete: () => { }
    }))
  }
  setDivision() {
    this.disableProceed = false;
    this.divData = this.dealerList.filter((division: any) => division.division_id == this.bookingForm.value.dealer);

    let priceData = {
      "dealer_code": this.divData[0].dealer_code,
      "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : ""
    }
    this.getVCPrice(priceData)
    this.clearDealerData(true);
    this.resetForm('dse');
    this.resetForm('paymentType');
    this.getDseList();
    if (this.isViaConfigurator) {
      this.getVehicleEdd();
      this.get_inventory_detail(this.divData[0].dealer_code);

    }


    //   if(this.EddData){
    //  let eddData =  this.EddData.filter((dealer:any)=>{
    //     if((dealer["Dealer Code"] == this.divData[0].dealer_code) &&
    //    (dealer["VC Code"] == this.productDetailList["vehicle_number"] )){
    //     return dealer;
    //    }
    //   })
    //   this.dealerData.emit({ dealerDataList: eddData[0] ? eddData[0] : null});
    // }
    if (this.divData[0]?.payment_details?.length > 1) {
      if (this.isVasAvailable && this.isViaConfigurator) {
        this.divData[0].payment_details.forEach((element: any) => {
          if (element.payment_gt_type == "RAZORPAY") {
            this.disableProceed = true;
            this.showPaymentOption = false;

            this.bookingForm.controls['paymentType'].setValue('ccavenue');
            this.bookingForm.get("paymentType").updateValueAndValidity();
            return;
          }
        });
      } else {
        this.disableProceed = false;
        this.bookingForm.controls['paymentType'].setValidators([Validators.required])
        this.bookingForm.updateValueAndValidity();
        this.showPaymentOption = true;
      }
    } else {
      if (this.isVasAvailable && this.isViaConfigurator && this.divData[0]?.payment_details?.length == 1) {
        this.divData[0].payment_details.forEach((element: any) => {
          if (element.payment_gt_type == "RAZORPAY") {
            this.disableProceed = true;
            this.bookingForm.controls['paymentType'].setValue('razorpay');
            this.bookingForm.get("paymentType").updateValueAndValidity();
            return;
          } else {
            this.disableProceed = false;

            this.bookingForm.controls['paymentType'].setValue('ccavenue');
            this.bookingForm.get("paymentType").updateValueAndValidity();
            return;
          }
        });

      } else {
        if (!this.isVasAvailable && !this.isViaConfigurator && this.divData[0]?.payment_details?.length == 1) {
          this.divData[0].payment_details.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.disableProceed = false;

              this.bookingForm.controls['paymentType'].setValue('razorpay');
              this.bookingForm.get("paymentType").updateValueAndValidity();
              return;
            } else {
              this.disableProceed = false;

              this.bookingForm.controls['paymentType'].setValue('ccavenue');
              this.bookingForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        }
        if (!this.isVasAvailable && this.isViaConfigurator && this.divData[0]?.payment_details?.length == 1) {
          this.divData[0].payment_details.forEach((element: any) => {
            if (element.payment_gt_type == "RAZORPAY") {
              this.disableProceed = false;

              this.bookingForm.controls['paymentType'].setValue('razorpay');
              this.bookingForm.get("paymentType").updateValueAndValidity();
              return;
            } else {
              this.disableProceed = false;

              this.bookingForm.controls['paymentType'].setValue('ccavenue');
              this.bookingForm.get("paymentType").updateValueAndValidity();
              return;
            }
          });
        }
      }
    }
  }

  bookNow() {
    this.btndisable=true;
    this.spinner.show()
    setTimeout(() => {
      this.btndisable=false;
      }, 100);
    if ((this.bookingForm.controls["aadhar"].value != ' ' && !this.isVasAvailable) || (this.bookingForm.controls["panNo"].value != ' ' && !this.isVasAvailable)) {
      if (this.bookingForm.controls["aadhar"].value != this.regexService.Aadhar) {
        this.isAdhaarVerified = false
        this.bookingForm.controls["aadhar"].setValidators([Validators.pattern(this.regexService.Aadhar)]);
        this.bookingForm.controls["aadhar"].updateValueAndValidity();
      }
      if (this.bookingForm.controls["panNo"].value != this.regexService.Pan) {
        this.bookingForm.controls["panNo"].setValidators([Validators.pattern(this.regexService.Pan),this.hasPatterncheckError()]);
        this.bookingForm.controls["panNo"].updateValueAndValidity();
      }
    }
    if (this.bookingForm.status === "INVALID") {
      this.formErrorService.displayFormErrors(this.bookingForm);
      if (this.isVasAvailable && this.bookingForm.controls["aadhar"].value.Invalid) {
        this.isAdhaarVerified = false
        this.toastrService.warning('Invalid format of Adhaar Card Number')
      }
      if (this.bookingForm.controls["aadhar"].value.Invalid) {
        this.isAdhaarVerified = false
        this.toastrService.warning('Invalid format of Adhaar Card Number')
      }
      this.spinner.hide()
      this.isSubmitForm = true;
      return;
    }
    if (((!this.isAdhaarVerified || !this.isPanVerified) && this.isVasAvailable && this.bookingForm.value.pan_type === 'Individual') || (!this.isPanVerified) && this.isVasAvailable && this.bookingForm.value.pan_type === 'Company') {
      this.toastrService.warning('Kindly Verify the e-KYC')
      this.spinner.hide()
      this.isSubmitForm = true;
      return;
    }

    // if(this.disableProceed && this.bookingForm.controls["paymentType"].value == 'razorpay' ){
    //   this.toastrService.warning("Payment is not mapped.");
    //   return;
    // }
    if (this.totalAmount > 500000) {
      this.spinner.hide();

      this.toastrService.warning("Payment cannot be more than 500000");
      return;
    }
    this.translate();



  }
  openPopup2(openForm: any) {
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: true,
      // windowClass: 'side-drawer'
    };
    this.modalService.open(openForm, ngbModalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  close() {
    if (isPlatformBrowser(this.platformId)) {
      this.modalService.dismissAll();
    }
  }
  closeModal() {
    // this.showModal = false;
  }
  translate() {
    this.spinner.show();
    let userdata = {
      data: [
        this.bookingForm.value.pan_type === 'Individual' ? this.bookingForm.value.first_name : this.bookingForm.value.full_name,
        this.bookingForm.value.pan_type === 'Individual'  ? this.bookingForm.value.last_name : '.',
        this.bookingForm.value.address1,
        this.bookingForm.value.address2
      ],
      isBulk: false,
      ignoreTaggedEntities: true,
      domain: 1,
      convertNumber: "Local",
    };
    this.sub.add(this.apiService.getTranslateText(userdata)
      .subscribe({
        next: (response: any) => {
          if (this.disableProceed && this.bookingForm.controls["paymentType"].value == 'razorpay') {
            if (this.isVasAvailable && (this.bookingForm.controls["paymentType"].value == 'RAZORPAY' ||
              this.bookingForm.controls["paymentType"].value == 'razorpay')) {
              this.displayAmt = this.totalAmount;
              this.spinner.hide();
            } else {
              this.spinner.hide();
              this.toastrService.warning("Payment is not mapped.");
              return;
            }
          }
          if (response.responseList[0].apiStatus == 2) {
            this.translatedFirstName = response.responseList[0].outString[0];
            this.translatedLastName = response.responseList[1].outString[0];
            this.translatedAddress1 = response.responseList[2].outString[0];
            this.translatedAddress2 = response.responseList[3].outString[0];
            this.booking();
          }
        },
        error: () => {
          this.translatedFirstName = this.bookingForm.value.pan_type === 'Individual' ? this.translatedFirstName = this.bookingForm.value.pan_type === 'Individual' ? this.bookingForm.value.first_name : this.bookingForm.value.full_name// this.CommonService.replaceUnicode(this.bookingForm.value.first_name) == '' ? this.bookingForm.value.first_name : this.CommonService.replaceUnicode(this.bookingForm.value.first_name);
          : this.bookingForm.value.full_name// this.CommonService.replaceUnicode(this.bookingForm.value.first_name) == '' ? this.bookingForm.value.first_name : this.CommonService.replaceUnicode(this.bookingForm.value.first_name);
          this.translatedLastName = this.bookingForm.value.pan_type === 'Individual'  ? this.CommonService.replaceUnicode(this.bookingForm.value.last_name) == '' ? this.bookingForm.value.last_name : this.CommonService.replaceUnicode(this.bookingForm.value.last_name) : '.'//this.CommonService.replaceUnicode(this.bookingForm.value.last_name) == '' ? this.bookingForm.value.last_name : this.CommonService.replaceUnicode(this.bookingForm.value.last_name);
          this.translatedAddress1 = this.CommonService.replaceUnicode(this.bookingForm.value.address1) == '' ? this.bookingForm.value.address1 : this.CommonService.replaceUnicode(this.bookingForm.value.address1);
          this.translatedAddress2 = this.CommonService.replaceUnicode(this.bookingForm.value.address2) == '' ? this.bookingForm.value.address2 : this.CommonService.replaceUnicode(this.bookingForm.value.address2);

          this.booking();
        },
        complete: () => { },
      })
    )
  }
  getQuantity() {
    if (this.bookingForm.controls['bookingpermission'].value == 'yes') {
      this.bookingForm.controls['bookinguseramount'].setValue(null);

    }

    if (this.bookingForm.value.quantity == "0") {
      this.bookingForm.patchValue({
        quantity: "1",
      });
    }
    //  this.totalAmount = (this.productDetailList["down_payment"]) * (this.bookingForm.controls['quantity'].value);
    if (this.totalAmount > 500000 && this.bookingForm.controls['bookinguseramount'].value < this.productDetailList["down_payment"])
      this.bookingForm.controls['quantity'].setValue(1);

    // this.totalAmount = (this.productDetailList["down_payment"]) * (this.bookingForm.controls['quantity'].value);
    if(this.isfnijourney && this.payment_data?.length > 0){
      this.totalAmount = (this.payment_data[0]?.amount) * (this.bookingForm.controls['quantity'].value);
    }else
    {
    this.totalAmount = (this.productDetailList["down_payment"]) * (this.bookingForm.controls['quantity'].value);
  }

    this.quantityChange.emit({ quantity: this.bookingForm.controls['quantity'].value, totalAmount: this.totalAmount });

  }
  changeBookingAmount() {
    this.bookingForm.get("quantity").updateValueAndValidity();
    if (this.bookingForm.controls['bookingpermission'].value == 'yes') {
      this.totalAmount = (this.bookingForm.controls['bookinguseramount'].value) * (this.bookingForm.controls['quantity'].value);
      if (this.totalAmount > 500000 && this.bookingForm.controls['bookinguseramount'].value < this.productDetailList["down_payment"])
        // this.totalAmount = (this.productDetailList["down_payment"]) * (this.bookingForm.controls['quantity'].value);

      if(this.isfnijourney && this.payment_data?.length > 0){
        this.totalAmount = (this.payment_data[0]?.amount) * (this.bookingForm.controls['quantity'].value);
      }else
      {
      this.totalAmount = (this.productDetailList["down_payment"]) * (this.bookingForm.controls['quantity'].value);
    }
      this.quantityChange.emit({ quantity: this.bookingForm.controls['quantity'].value, totalAmount: this.totalAmount });

    }
  }
  changeUsrBkgPerm(event) {
    event && event.target.value == 'yes'
      // ? this.bookingForm.controls['bookinguseramount'].setValidators([Validators.required, Validators.min(1)])
      ? this.bookingForm.controls['bookinguseramount'].setValidators([Validators.required, Validators.min((this.productDetailList["down_payment"]))])
      : this.bookingForm.get("bookinguseramount").clearValidators();
    this.bookingForm.get("bookinguseramount").updateValueAndValidity();
    this.bookingForm.updateValueAndValidity();
    if (event && event.target.value == 'no') {

      this.bookingForm.controls['bookinguseramount'].setValue(null);
      this.bookingForm.controls['bookinguseramount'].clearAsyncValidators();
      this.bookingForm.get("bookinguseramount").updateValueAndValidity();

      // this.totalAmount = this.productDetailList["down_payment"] ? this.productDetailList["down_payment"] * this.bookingForm.controls['quantity'].value : 0;
      if(this.isfnijourney && this.payment_data?.length > 0){
        this.totalAmount = (this.payment_data[0]?.amount) * (this.bookingForm.controls['quantity'].value);
      }else
      {
        this.totalAmount = this.productDetailList["down_payment"] ? this.productDetailList["down_payment"] * this.bookingForm.controls['quantity'].value : 0;
    }
      this.quantityChange.emit({ quantity: this.bookingForm.controls['quantity'].value ? this.bookingForm.controls['quantity'].value : 1, totalAmount: this.totalAmount });
    }
  }

  callPaywithRazor() {
    let response = this.responseData;
    let finalAmount;
    // = this.productDetailList["down_payment"] * this.quantity;
    if (this.bookingForm.controls['bookingpermission'].value == 'yes' &&
      this.bookingForm.controls['bookinguseramount'].valid && this.totalAmount <= 500000) {
      // this.totalAmount
      if (this.bookingForm.controls['bookinguseramount'].value == '' || this.bookingForm.controls['bookinguseramount'].value <= 0) {
        this.toastrService.warning('Please enter valid amount');
        this.spinner.hide();
        return;
      } else {
        finalAmount = this.bookingForm.controls['bookinguseramount'].value
      }
    } else {
      finalAmount = this.productDetailList["down_payment"]
    }
    let orderDetails = {
      razorpay_account_id: response["data"].razorpay_account_id,
      razorpay_access_key: response["data"].razorpay_access_key,
      order_id: response["data"].payment_order_id,
      pay_amount: this.productDetailList["down_payment"],
      product_name: response["data"]?.lead_info.pl,
      product_description: response["data"]?.lead_info.vehicle_number,
      shopping_order_id: response["data"].lead_row_id,
      email: response["data"].email_id,
      contact: response["data"].mobile_number,
    };
    this.payMessage = "Request In Process";
    this.isVerifyOtp = true;
    this.payWithRazor(orderDetails, this.leadInfo, finalAmount);
    this.otpInputValue = "";
    this.toastrService.success(response.data.msg);
  }
  async booking() {
      this.spinner.show();
      let currentDateTime = formatDate(new Date(), "yyyy-MM-dd HH:mm:ss", "en-US");
      this.quantity = this.bookingForm.value.quantity;
      this.bookingForm.updateValueAndValidity();
      let finalAmount;
      // = this.productDetailList["down_payment"] * this.quantity;
      if (this.bookingForm.controls['bookingpermission'].value == 'yes' &&
        this.bookingForm.controls['bookinguseramount'].valid && this.totalAmount <= 500000) {
        // this.totalAmount
        if (this.bookingForm.controls['bookinguseramount'].value == '' || this.bookingForm.controls['bookinguseramount'].value <= 0) {
          this.toastrService.warning('Please enter valid amount');
          this.spinner.hide();
          return;
        } else {
          finalAmount = this.bookingForm.controls['bookinguseramount'].value
        }
      } else {
        finalAmount = this.productDetailList["down_payment"]
      }
      // if(this.VasData?.VASBookingAmount ){
      //   if(Number(finalAmount) + Number(this.VasData.VASBookingAmount) > 500000){
      //     this.spinner.hide();
      //     this.toastrService.warning('*Maximum booking amount limit is set to 5 Lacs.');
      //     return;
      //   }
      // }
      // finalAmount =
      if (this.bookingForm['status'] == 'INVALID') {
        if (this.isVasAvailable && this.bookingForm.controls["aadhar"].value.Invalid) {
          this.isAdhaarVerified = false
          this.toastrService.warning('Invalid format of Adhaar Card Number')
        }
        this.spinner.hide();

        return
      }

      let statedata: any = this.stateList.filter(
        (result) => result.code === this.bookingForm.value.state
      );
      // let state = this.bookingForm.value.state;
      // let statedata = state.split(",");
      // let ll = {
      //   code: statedata[0].code,
      //   state: statedata[0].name,
      // };

      this.dse = [];
      if (this.bookingForm.value.dse && this.dseList?.length > 0) {
        this.dseMatch = false;
        this.dse = [];

        this.dseList.forEach((element) => {
          if ((element.username)?.toLowerCase() == (this.bookingForm.value.dse)?.toLowerCase()) {
            this.dseMatch = true;
            this.dse = element;
          }
        });
        if (!this.dseMatch) {
          this.toastrService.error("Provided CRM ID : DSE/NSE/DDSO/DSM/NDRM/DSAdmin does not match with the dealer.");

        }
      }
      let useradhar = this.bookingForm.value.aadhar ? this.bookingForm.value.aadhar :"";
      this.encryptAdharNO = this.localStorage.encryptData(useradhar);

      this.state = statedata[0]?.["name"];
      let data = {
        "lead_type": this.typeOfBooking ? "FINANCE" : "BOOKING",
        "mm_geography": this.divData[0]?.mm_geography ? this.divData[0]?.mm_geography : "",
        "division_id": this.divData[0]?.division_id ? this.divData[0]?.division_id : "",
        "lob": this.productDetailList.lob ? this.productDetailList.lob : "",
        "mobile_number": this.userData.mobile_number,
        "email_id": this.bookingForm.controls['email_id'].value,
        "first_name": this.translatedFirstName.trim(),
        "last_name": this.bookingForm.value.pan_type === 'Individual' ? this.translatedLastName.trim() : '.',
        "address_one": this.translatedAddress1.trim()
          ? (this.translatedAddress1.trim()).substring(0, 59)
          : this.translatedFirstName.trim() +
          statedata[0]?.["code"] +
          this.userData.mobile_number +
          currentDateTime,
        "address_two": this.translatedAddress2.trim(),
        "state": statedata[0]?.["name"],
        "state_code": statedata[0]?.["code"],
        "district": this.bookingForm.value.district,
        "organization_name":
          // lob == "HCV Cargo" || lob == "MCV Trucks" || lob == "HCV Const" || lob == "ICV Trucks"?
          this.translatedFirstName.trim() + this.translatedLastName.trim() + this.userData?.mobile_number
        // : ""
        ,
        "vehicle_application": "NA",
        "body_type": "NA",
        "usage_category": "",
        "vc_description": this.productDetailList["product_description"] ? this.productDetailList["product_description"] : "",
        "vc_number": this.productDetailList["vehicle_number"] ? this.productDetailList["vehicle_number"] : "",
        "ppl": this.productDetailList["ppl"] ? this.productDetailList["ppl"] : "",
        "vc_id": this.productDetailList["vehicle_id"] ? this.productDetailList["vehicle_id"] : "",
        "pl": this.productDetailList["pl"] ? this.productDetailList["pl"] : "",
        "quantity": String(this.bookingForm.value.quantity),
      // "quantity": String(1),
        "amc": this.isVasAvailable ? 'yes' : this.bookingForm.value.annulMaintenance ? this.bookingForm.value.annulMaintenance : "",
        "lease_interest": this.bookingForm.value.leasingInterest ? this.bookingForm.value.leasingInterest : "",
        "finance_account_id": this.bookingForm.value.financeDrp.id ? this.bookingForm.value.financeDrp.id : "1-39ERX-657",
        "finance": this.bookingForm.value.financeDrp ? this.bookingForm.value.financeDrp : "SELF",
        "model": this.productDetailList["model"] ? this.productDetailList["model"] : "",
        "is_tml": "True",
        "interested_in_exchange": "No",
        "brand": "",
        "registration_number": "",
        "pi_for_exchange": "",
        "chassis_number": "",
        "manufacture_year": "",
        "mileage": "",
        "action_type": this.divData[0]?.payment_details?.length == 0 ? "Unbilled" : "Billed",
        "down_payment": Number(finalAmount),
        "payment_gateway_type": this.bookingForm.controls["paymentType"].value == "ccavenue" ? "CCAVENUE" : "RAZORPAY",
        // "channel": this.isViaConfigurator ? 'OSP_Configurator' : 'Online Booking',
      channel: this.VasData?.isViaOSPVas ? 'Fleet Verse' : (this.isSmart || this.isViaConfigurator) ? 'Fleet Verse Configurator' : 'Fleet Verse',
        "source": this.utmdata ? this.utmdata?.source : '',
        "medium": this.utmdata ? this.utmdata?.medium : '',
      // "source":  this.isDisabled ? this.dealerCode : this.utmdata?.source ? this.utmdata?.source : '' ,
      //   "medium":  this.isDisabled  ? 'DealerLandingLink': this.utmdata?.medium ? this.utmdata?.medium :'' ,
        "campaign": this.utmdata ? this.utmdata?.campaign || this.utmdata?.utm_campaignname : '',
        "campaign_id": this.utmdata ? this.utmdata?.campaign_id : '',
        "lead_origin": 'Booking',
        "ex_showroom_price": Math.round(this.newVCPriceChange),
        "pan_type":this.bookingForm.value.pan_type ? this.bookingForm.value.pan_type : ''
      };
      data['pan_no'] = this.bookingForm.value.panNo ? this.bookingForm.value.panNo : "";
    data["aadhar_number"] = this.encryptAdharNO ? this.encryptAdharNO : "";
      data['dse_first_name'] = this.dseMatch ? this.dse['first_name'] : "";
      data['dse_last_name'] = this.dseMatch ? this.dse['last_name'] : "";
      data['dse_username'] = this.dseMatch ? this.dse['username'] : "";
      if (this.typeOfBooking) {
        data['row_id'] = this.leadData.row_id;
        data['opty_id'] = this.leadData.opty_id;
      }
      if (this.isVasAvailable) {

        let vasDataArray = [];

        if (Array.isArray(this.VasData.VASPLAN)) {
          // Handle VASPLAN as an array
          vasDataArray = this.VasData.VASPLAN.map((plan,index) => {
            let vas_data = {
              payment_gateway_type: this.bookingForm.controls["paymentType"].value === "ccavenue" ? "CCAVENUE" : "RAZORPAY",
              vas_category: plan.plan,
              // vas_payble_amount: this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0,
              vas_payble_amount: index === 0 ? (this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0) : 0,
              chassis_number: "",
              vc_number: this.VasData.VCNUMBER,
              application: this.VasData.vasApplication,
              terrian: this.VasData.terrian,
              avg_monthly_km: this.VasData.AnnualKms,
              no_of_years: plan['contract years'] && Number(plan['contract years']) > 0 ? (Number(plan['contract years']) * 12).toString() : (plan['contract years'] === '' ? (1 * 12).toString() : ''),
              // no_of_years: this.VasData.NoOfyears.toString(),
              "quantity": "1",
              recommended_quantity: this.VasData?.recommended_quantity ? this.VasData?.recommended_quantity : "1",
              channel: this.VasData?.isViaOSPVas
                ? "Fleet Verse"
                : (this.isSmart || this.isViaConfigurator)
                  ? "Fleet Verse Configurator" : "Fleet Verse",
              fuel_type: this.VasData.fuel_type || this.productDetailList.fuel_type,
              is_amc: index === 0 ? true : false,
              // ...(plan.is_vas_recommendation ? { "is_vas_recommendation": plan.is_vas_recommendation } : {})
            };

            if (this.typeOfBooking === "Finance") {
              vas_data["retry_payment"] = true;
              if (this.VasData?.id) {
                vas_data["vas_id"] = this.VasData.id;
              }
            }

            return vas_data;
          });
          data['is_vas_recommendation'] = true;
        } else {
          // Handle VASPLAN as a single value

   let vas_data = {
          "payment_gateway_type": this.bookingForm.controls["paymentType"].value == "ccavenue" ? "CCAVENUE" : "RAZORPAY",
          "vas_category": this.VasData.VASPLAN,
          "vas_payble_amount": this.VasData.VASBookingAmount ? Number(this.VasData.VASBookingAmount) : 0,
          "chassis_number": "",
          "vc_number": this.VasData.VCNUMBER,
          "application": this.VasData.vasApplication,
          "terrian": this.VasData.terrian,
          "avg_monthly_km": this.VasData.AnnualKms,
          "no_of_years": (this.VasData.NoOfyears).toString(),
          "quantity": "1",
          "recommended_quantity": this.VasData?.recommended_quantity ? this.VasData?.recommended_quantity : "1",
          // "channel": this.VasData ? 'OSP_Configurator' : 'Online Booking',
        // "channel": this.isSmart || this.VasData ? 'OSP_Configurator' : 'Online Booking',
        channel: this.VasData?.isViaOSPVas ? 'Fleet Verse' : (this.isSmart || this.isViaConfigurator) ? 'Fleet Verse Configurator' : 'Fleet Verse',

          "fuel_type": this.VasData.fuel_type ? this.VasData.fuel_type : this.productDetailList.fuel_type,
          ...(this.VasData.is_amc ? { "is_amc": this.VasData.is_amc } : {})
          // "stock": this.stock,
        }
        if (this.typeOfBooking == 'Finance') {
          vas_data["retry_payment"] = true
          if (this.VasData) {
            vas_data["vas_id"] = this.VasData.id
          }
        }
          vasDataArray = [vas_data];
        }


      data['vas_data'] = vasDataArray;

      }

      data["stock"] = this.stock

      if ((data.address_one)?.length > 60) {
        data["address_one"] = this.translatedAddress1.trim()
          ? (this.translatedAddress1.trim()).substring(0, 59)
          : (this.translatedFirstName.trim() +
            statedata[0]?.["code"] +
            this.userData.mobile_number +
            currentDateTime).substring(0, 59)
      }
      if ((data.organization_name)?.length > 50) {
        data['organization_name'] = this.translatedFirstName.trim() +
          this.userData.mobile_number;
      }
      if (data.organization_name?.length > 50) {
        data['organization_name'] = (this.translatedFirstName.trim()).substring(0, 39) +
          this.userData.mobile_number;
      }
      this.clevertap();
      this.clevertapPayment();
      if (this.leadData && this.leadData['lead_type'] == 'FINANCE') {
        data["taluka"] = this.leadData.taluka;
        data["city"] = this.leadData.city;
        data["pincode"] = this.leadData.pincode;
      }
      this.sub.add(this.apiService.generateLead(data).subscribe({
        next: async (response: any) => {
          if (response["success"]) {
            let id = localStorage.getItem('tat_id');
            if (id !== null && id !== undefined) {
            try {
              await this.vastatrequestresponsereturn(response?.data?.lead_info?.row_id); // Wait for API response
            } catch (error) {
              console.error("Error in vastatrequestresponse:", error);
            }
           }  
            var unxPayload = [
              {
               pid: (this.productDetailList.vehicle_number).toString(),
               variantId: this.productDetailList.vehicle_number, // Only if variant is present
               qty: String(this.bookingForm.value.quantity),
               price: (this.productDetailList.price_range).toString()
               }]
            unbxUrl.fireUnbxdOrder(unxPayload)
            const schemeValue = localStorage.getItem('schemeDetails');
            const storedSchemeCode = localStorage.getItem('schemeCode');


            const accumulationData = {
              mobile_number: this.userData.mobile_number,
              source: "OSP",
              order_number: response["data"]?.lead_info.row_id,
              scheme_code: storedSchemeCode,
              // status: "Completed",
              action_type: "add",
            };

            // this.userAaccumulation(accumulationData)
            // const dealercd = localStorage.getItem('dealercd');

            // let dealerCode = this.schemeDealeCodes.includes(dealercd) ? true : false
            if (storedSchemeCode) {
              this.userAaccumulation(accumulationData)
            }

            this.setUserData();
            this.clevertap();
            this.spinner.hide();
            this.leadInfo = response.data;
            if (this.divData[0]?.payment_details?.length == 0) {
              this.toastrService.success(response.data.msg);
              this.router.navigate(["account/booking"]);
            }
            else {
              if (this.isVasAvailable && (this.bookingForm.controls["paymentType"].value == 'RAZORPAY' || this.bookingForm.controls["paymentType"].value == 'razorpay')) {
                this.spinner.hide();
                // this.openPopup2(this.vasRPay);
                this.responseData = response;
                this.callPaywithRazor()
              } else {
                if (this.bookingForm.controls["paymentType"].value == "ccavenue") {
                  this.getCcAvenueEncryptionKey(response, data, this.leadInfo, this.isVasAvailable, this.VasData);
                } else {
                  // this.GoogleProcessPayment("click_billingdetails_proceedtopay_success");
                  let orderDetails = {
                    razorpay_account_id: response["data"].razorpay_account_id,
                    razorpay_access_key: response["data"].razorpay_access_key,
                    order_id: response["data"].payment_order_id,
                    pay_amount: this.productDetailList["down_payment"],
                    product_name: response["data"]?.lead_info.pl,
                    product_description: response["data"]?.lead_info.vehicle_number,
                    shopping_order_id: response["data"].lead_row_id,
                    email: response["data"].email_id,
                    contact: response["data"].mobile_number,
                  };
                  this.payMessage = "Request In Process";
                  this.isVerifyOtp = true;
                  this.payWithRazor(orderDetails, this.leadInfo, finalAmount);
                  this.otpInputValue = "";
                  this.toastrService.success(response.data.msg);
                }
              }
            }
          }
          else {
          this.btndisable=false
            this.spinner.hide();
          if(response.data.msg==='You already have an active request in Tata Motors system.' || response.data.msg === 'You already have active request against this vehicle. Please visit My Booking Request section in Profile to complete the process.'){
            this.errormessage=response.data.msg;
            $('#popuperrorgeneral').modal('show');
          }
          else{
            this.toastrService.warning(response.data.msg);
          }
          }
        },
        error: () => {
          this.spinner.hide();

        },
        complete: () => {
          this.spinner.hide();

        }
      }));

  }
  setUserData() {
    this.sub.add(this.apiService.getUserData().subscribe({
      next: (response: any) => {
        this.rootService.setUser(response["data"]);
        this.rootService.setUserId(response["data"]);
        this.userData = response["data"];
        this.localStorage.setItem("userData", JSON.stringify(this.userData));

        this.behaviourSubject.isLoggedIn.next(true);
      }
    })
    );
  }
  getCcAvenueEncryptionKey(response: any, orderDetails: any, leadInfo: any, isVasAvailable, VasData) {
      let subAccId: string = "";
      this.divData[0].payment_details.forEach((element: any) => {
        if (element.payment_gt_type == "CCAVENUE") {
          subAccId = element.account_id;
        }
      });
      let finalAmount = orderDetails["down_payment"] * orderDetails["quantity"]
      if (isVasAvailable) {
        finalAmount = Number(finalAmount) + Number(VasData.VASBookingAmount)
      }
      let data = {
        "data": {
          "amount": Number(finalAmount),
          "billing_address": "",
          "billing_city": "",
          "billing_email": "",
          "billing_country": "India",
          "billing_name": this.CommonService.replaceUnicode(orderDetails?.first_name) + " " + this.CommonService.replaceUnicode(orderDetails?.last_name),
          "billing_state": orderDetails?.state,
          "billing_tel": orderDetails?.mobile_number,
          "billing_zip": "",
          "cancel_url": this.ccavenue.redirectURL,
          "currency": "INR",
          "customer_identifier": "",
          "delivery_address": "",
          "delivery_city": "",
          "delivery_country": "India",
          "delivery_name": this.CommonService.replaceUnicode(orderDetails?.first_name) + " " + this.CommonService.replaceUnicode(orderDetails?.last_name),
          "delivery_state": orderDetails?.state,
          "delivery_tel": orderDetails?.mobile_number,
          "delivery_zip": "",
          "language": "EN",
          "merchant_id": this.ccavenue.merchant_id,
          "order_id": response["data"].payment_order_id,
          "promo_code": "",
          // "sub_account_id":subAccId,
          "redirect_url": this.ccavenue.redirectURL
        },

        working_key: this.ccavenue.workingKey,
      };
      // if (isVasAvailable) {

      //   data.data["split_tdr_charge_type"] = "M",
      //     data.data["merComm"] = "0";
      //   data.data["split_data_list"] = [
      //     // { "splitAmount": VasData.VASBookingAmount, "subAccId": (this.ccavenue.subAccId).toString() },
      //     // { "splitAmount": orderDetails["down_payment"] * orderDetails["quantity"], "subAccId": (subAccId).toString() }
      //     { "splitAmount":  Number(finalAmount) * orderDetails["quantity"], "subAccId": (subAccId).toString() }
      //   ]

      // } else {
        data.data["sub_account_id"] = subAccId

      // }

        this.payMessage =
          "Your payment of ₹" +
          this.formatMoney(finalAmount) +
          "/-";
        const objthank: ThankuResponse = {} as ThankuResponse;
        objthank.headMessage = "Thank You !";
        objthank.payMessage = this.payMessage;
        objthank.Image = this.imageUrl;
        objthank.orderId = response["data"].payment_order_id;
        objthank.leadInfo = leadInfo;
        objthank.reqId = response["data"].lead_row_id;
        objthank.vehicleID = this.productDetailList["id"];
        objthank.vehicleModel = this.productDetailList["model"];
        objthank.orderAmount = response["data"].payment_amount / 100;
        objthank.productUrl = window.location.href;
        objthank.payment_gateway = orderDetails["payment_gateway_type"]
        this.localStorage.setItem("Payresponse", JSON.stringify(objthank));

      this.sub.add(this.apiService.getCCEncTokenDetail(data).subscribe({
        next: (res: any) => {
          if (res.success) {

            let encRequest = res.data;
            let ccavenuForm: FormGroup = this.formBuilder.group({
              encRequest: [encRequest],
              access_code: [this.ccavenue.accessCode],
            });
            this.payWithCcavenu(ccavenuForm);
          } else {
            this.toastrService.warning("Payment Aborted");
          }
        }
      })
      );

  }
  payWithCcavenu(formGroup: FormGroup) {
    // localStorage.removeItem('productOfferData');

    if (this.VasData) {
      localStorage.removeItem('VASData')
      this.behaviourSubject.vasCreated.next(true);
    }

    const myform = document.createElement("form");
    myform.method = "POST";
    myform.action = this.ccavenue.baseurl;
    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement("input");
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }
    myform.style.display = "none";
    myform.append("Content-Type", "application/x-www-form-urlencoded");
    myform.append(
      "Accept",
      "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8"
    );
    document.body.appendChild(myform);
    myform.submit();
  }

payWithRazor(orderDetails: any, leadInfo: any, finalAmount: any) {
  if (isPlatformBrowser(this.platformId)) {
    const ResponseData: PaymentResponse = {} as PaymentResponse;
    const options: any = {
      key: orderDetails.razorpay_access_key,
      amount: orderDetails.pay_amount,
      currency: "INR",
      name: orderDetails.product_name, //'VSS', // company name or product name
      description: orderDetails?.product_description ? orderDetails?.product_description : "", //'Star City Bus',  // product description
      image: `${this.environment1}assets/images/tata-logo.png`, // company logo or product image
      order_id: orderDetails.order_id, // order_id created by you in backend
      account_id: orderDetails.razorpay_account_id,
      prefill: {
        email: orderDetails.email,
        contact: orderDetails.contact,
      },
      modal: {
        escape: false,
      },
      notes: {
        shopping_order_id: orderDetails.shopping_order_id,
      },
      theme: {
        color: "#0c238a",
      },
    };
    options.handler = (response: any) => {
      this.payMessage =
        "Your payment of ₹" +
        // this.formatMoney(this.productDetailList["down_payment"]) +
        this.formatMoney(orderDetails.pay_amount) +
        "/- received against Request ID " +
        orderDetails.shopping_order_id +
        ".";
      this.isVerifyOtp = true;
      this.isconfirm = true;
      this.isProcess = false;
      options.response = response;
      ResponseData.razorpay_payment_id = response.razorpay_payment_id;
      ResponseData.razorpay_order_id = response.razorpay_order_id;
      ResponseData.razorpay_signature = response.razorpay_signature;
      this.sub.add(this.apiService.getPaymentDetail(ResponseData).subscribe({
        next: (response: any) => {
          this.modalService.dismissAll();

          this.transactionComplete = true;

          if (response.success) {
            this.transactionSuccess = true;
            this.paymentSuccess = response.data;

            this.isProcess = false;
            this.isconfirm = true;
            // this.googleAnlyaticspayment(
            //   "click_payment_success",
            //   orderDetails.shopping_order_id,
            //   this.payMessage,
            //   orderDetails.pay_amount
            // );
            const objthank: ThankuResponse = {} as ThankuResponse;
            objthank.headMessage = "Thank You !";
            objthank.payMessage = this.payMessage;
            objthank.Image = this.imageUrl;
            objthank.leadInfo = leadInfo;
            objthank.orderAmount = finalAmount

            objthank.orderId = leadInfo.order_id;
            objthank.reqId = leadInfo.lead_row_id;
            objthank.transactionStatus = 'success';
            objthank.payment_gateway = "RAZORPAY";
            // localStorage.removeItem('productOfferData');

            if (this.VasData) {
              localStorage.removeItem('VASData')
              this.behaviourSubject.vasCreated.next(true);
            }
            this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
            this.clevertapPayementcompFailed(response.data['lead_info'].booking_amount);
            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {
            // localStorage.removeItem('productOfferData');

            if (this.VasData) {
              localStorage.removeItem('VASData')
              this.behaviourSubject.vasCreated.next(true);
            }
            this.clevertapPayementFailed(response.data['lead_info'].booking_amount);
            this.transactionfailed = true;

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        },
        error: () => { },
        complete: () => {
        }
      }))

    };
    options.modal.ondismiss = () => {
      this.payMessage =
        "Your payment against Request ID " +
        orderDetails.shopping_order_id +
        " of ₹" +
        // this.formatMoney(this.productDetailList["down_payment"]) +
        this.formatMoney(orderDetails.pay_amount) +
        "/- is not received.";
      this.isVerifyOtp = true;
      const objthank: ThankuResponse = {} as ThankuResponse;
      objthank.headMessage = "Sorry !";
      objthank.payMessage = this.payMessage;
      objthank.Image = this.imageUrl;
      objthank.leadInfo = leadInfo;
      objthank.orderAmount = finalAmount

      objthank.reqId = leadInfo.lead_row_id;
      objthank.transactionStatus = 'failure';
        objthank.productUrl = window.location.href;
      objthank.payment_gateway = "RAZORPAY";

      this.localStorage.setItem("Payresponse", JSON.stringify(objthank));
      const ResponseDatas: PaymentResponse = {} as PaymentResponse;
      ResponseDatas.razorpay_order_id = orderDetails.order_id;
      this.sub.add(this.apiService.getPaymentCancelDetail(ResponseDatas).subscribe({
        next: (response: any) => {
          this.isProcess = false;
          this.isconfirm = true;
          if (response.success) {
            // localStorage.removeItem('productOfferData');

            if (this.VasData) {
              localStorage.removeItem('VASData')
              this.behaviourSubject.vasCreated.next(true);
            }

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          } else {
            // localStorage.removeItem('productOfferData');

            if (this.VasData) {
              localStorage.removeItem('VASData')
              this.behaviourSubject.vasCreated.next(true);
            }
            this.clevertapPayementFailed(this.leadInfo['lead_info'].booking_amount);
            this.transactionfailed = true;

            this.ngZone.run(() => this.router.navigate(["/order-status"])).then();
          }
        }
      }));
    };
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
    return ResponseData;
  }
}
  formatMoney(amount: any, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      let i: any;
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
      const negativeSign = amount < 0 ? "-" : "";
      i = parseInt((amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))).toString();
      let j = i?.length > 3 ? i?.length % 3 : 0;
      return (
        negativeSign +
        (j ? i.substr(0, j) + thousands : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount
          ? decimal +
          Math.abs(amount - i)
            .toFixed(decimalCount)
            .slice(2)
          : ""));
    } catch (e) {

    }
  }
  getStateList(lob: any) {
    this.stateList = [];
    this.clearDealerData(false);
    if (this.dealerCode && this.dealerLen > 0) {
      lob = {
        lob: lob,
        dealer_code: this.dealerCode,
      };
    }
    else {
      lob = {
        lob: lob,
      };
    }
    this.sub.add(this.apiService.getLocations(lob).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.stateList = response["data"];
          if (this.dealerCode && this.dealerLen > 0) {
            this.bookingForm.patchValue({ "state": this.stateList[0].code });
            this.getDistrictList(this.stateList);
          }

        }
      },
      error: () => {
      },
      complete: () => {
        if (!this.dealerCode || this.dealerLen == 0) {
          this.getUserDetails();
        }
      }
    })
    );
  }

  async getDistrictList(statecodes?) {

    this.dseList = [];
    this.districtList = [];
    this.clearDealerData(false);
    this.resetForm('district');
    this.resetForm('dealer');
    this.resetForm('dse');
    let ll;

    if (statecodes) {
      ll = {
        code: statecodes[0].code,
        state: statecodes[0].name,
      };
    } else {

      let statedata: any = this.stateList.filter(
        (result) => result.code
          === this.bookingForm.value.state
      );

      // let state = this.bookingForm.value.state;
      // let statedata = state.split(",");
      ll = {
        code: statedata[0].code,
        state: statedata[0].name,
      };
    }

    let stateData: any = {
      state: ll,
      lob: this.lobName,
    };
    if (this.dealerCode && this.dealerLen > 0) {
      stateData = {
        state: ll,
        lob: this.lobName,
        dealer_code: this.dealerCode,

      };
    }
    else {
      stateData = {
        state: ll,
        lob: this.lobName,
      }
    }
    await this.sub.add(this.apiService.getLocations(stateData).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.districtList = response["data"];
          if (this.dealerCode && this.dealerLen > 0 && this.districtList?.length == 1) {
            this.bookingForm.patchValue({ "district": this.districtList[0] });
          }
          if (this.typeOfBooking || this.userData && statecodes && !this.dealerCode) {
            this.getDealerList();
          }
          if (this.dealerCode && this.districtList?.length == 1) {
            this.getDealerList();

          }
        }
      },
      error: () => {
      },
      complete: () => {
      }
    })
    );
  }
  getDealerList() {
    this.resetForm('dealer');
    this.resetForm('dse');

    this.clearDealerData(false);
    this.showPaymentOption = false;
    let statedata: any = this.stateList.filter(
      (result) => result.code
        === this.bookingForm.value.state
    );
    let ll;
    let data: any

    if (this.dealerCode && this.dealerLen > 0) {
      ll = {
        code: statedata[0].code,
        state: statedata[0].name,
      };
      data = {
        district: this.bookingForm.value.district,
        state: ll.code,
        lob_name: this.lobName ? this.lobName : "",
        vc: this.productDetailList.vehicle_number,
        dealer_code: this.dealerCode
      };
    }
    else {
      ll = {
        code: statedata[0].code,
        state: statedata[0].name,
      };
      data = {
        district: this.bookingForm.value.district,
        state: ll.code,
        lob_name: this.lobName ? this.lobName : "",
        vc: this.productDetailList.vehicle_number
      };
    }
    this.sub.add(this.apiService.getDealerList(data).subscribe({
      next: (response: any) => {
        if (response["success"]) {
          this.dealerList = response["data"];
          if (response["data"]?.length == 1 && !this.typeOfBooking && this.dealerCode) {
            this.bookingForm.patchValue({
              dealer: this.dealerList[0].division_id,
            });
            this.setDivision();
            // this.getDseList();
          }
          if (this.typeOfBooking) {
            this.bookingForm.patchValue({
              dealer: this.leadData.division_id,
            });
            this.setDivision();

          }
        }
      },
      error: (error) => {
        this.toastrService.warning(error.data.msg);

      },
      complete: () => {
      }
    })
    );
  }
  resetForm(value: any) {
    if (value == 'paymentType') {
      this.showPaymentOption = false;
    }
    this.bookingForm.controls[value].setValue('');
    this.bookingForm.get(value).updateValueAndValidity();

  }

  async getDealer() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("dealername");
      {
        this.divisionList = [];
        let data = {
          lob_name: this.lobName ? this.lobName : "",
          dealer_code: this.dealerCode,
          action_type: "dropdown"
        };
        this.sub.add(this.apiService.getDealerList(data).subscribe({
          next: (response: any) => {
            if (response["success"]) {
              this.dealerLen = response?.data?.length;
              if (this.dealerLen > 0) {
                this.getStateList(this.productDetailList.lob);

              }
              this.dealerList = [];
              response["data"].forEach((res) => {
                this.dealerList.push(res);
              });

              this.dealername = response?.data;
              localStorage.setItem("dealername", (this.dealername[0].division_name + '_' + this.dealername[0].dealer_code))
              this.behaviourSubject.dealerName.next(true)
            }
            else {
            }
          },
          error: (error) => {
            this.toastrService.warning(error.data.msg);
          },
          complete: () => {
          }
        })
        );

      }
    }
  }

  clearDealerData(isDivisionChange: boolean) {
    if (isDivisionChange == false) {
      this.dealerList = [];
      this.divData = [];
    }
    this.finance = true;
    this.bookingForm.controls['bookingpermission'].setValue("no");
    this.bookingForm.controls['haveFinancialApproval'].setValue("yes");
    this.bookingForm.get("paymentType").updateValueAndValidity();
    this.bookingForm.controls['paymentType'].removeValidators([Validators.required]);
    this.bookingForm.controls['bookinguseramount'].setValue(null);
    this.bookingForm.controls['bookinguseramount'].clearAsyncValidators();
    this.bookingForm.get("bookinguseramount").updateValueAndValidity();
  }
  async getDseList() {
    {
      this.dseList = [];
      let code;
      let divisionId = this.divData[0]?.division_id;
      this.dealerList.forEach((res) => {
        if (res.division_id == divisionId) {
          code = res.dealer_code
        }
      });
      this.dseList = [];
      let data = {
        lob: this.productDetailList.lob,
        dealer_code: code,
        division_id: code ? divisionId : "",
      };
      this.sub.add(this.apiService.getDSEList(data).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.dseList = response.data;
          } else {
            this.dseList = [];
          }
        }
      }));
    }
  }
  onlyNumberKey(event: any) {
    return this.regexService.NumberKeyEvent(event);
  }
  notAllowSpace(event: any) {
    if ((event.target.selectionStart === 0 && event.which === 32) || event.key === '.') {
      event.preventDefault();
    }
  }
  alphanumbericOnlyFirstLastName(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]|[.]|[ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  get_inventory_detail(dealerCode?) {
    let data = {
      vc_number: this.productDetailList.vehicle_number,
      dealer_code: dealerCode,

    };
    this.sub.add(this.apiService.getinventorydetails(data).subscribe({
      next: (response: any) => {
        if (response.quantity) {
          this.stock = response.quantity;
        }
        else {
          this.stock = 0;
        }
      }
    }));
  }

  getVehicleEdd() {
    let data = {
      vc: this.productDetailList.vehicle_number,
      dealer_code: this.divData[0].dealer_code,
    };
    this.sub.add(this.apiService.getVehicleEddData(data).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.dealerData.emit({ dealerDataList: response.data ? response.data : null });
        } else {

        }
      }
    }));
  }



  clevertap() {
    if (isPlatformBrowser(this.platformId)) {

      try {
        var baseurl = window.location.href;
        this.cleverService.proceedToPayment(
          this.CommonService.replaceUnicode(this.bookingForm.value.first_name),
          this.CommonService.replaceUnicode(this.bookingForm.value.last_name),
          this.userData.mobile_number,
          this.bookingForm.value.email_id,
          this.state,
          "",
          this.bookingForm.value.district,
          "",
          "",
          this.divData[0].division_name,
          "BOOKING",
          this.bookingForm.value.finance?.name ? this.bookingForm.value.finance?.name : "",
          this.bookingForm.value.quantity,
          this.productDetailList["id"],
          this.productDetailList?.images[0]?.image_url,
          this.productDetailList["model"],
          baseurl,
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          this.dseMatch ? this.dse['username'] : "",
          this.bookingForm.value.haveFinancialApproval,

          this.productOfferData?.financierName ?
            this.productOfferData?.financierName : this.bookingForm.value.financeDrp ? this.bookingForm.value.financeDrp : "SELF",
          this.bookingForm.value.annulMaintenance ? this.bookingForm.value.annulMaintenance : "",
          "",
          "",
          "",
          "",
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.router.url
        );
      } catch (error) { }
    }
  }

  clevertapPayment() {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentOptionSelected(
          "Online Transfer",
          this.productDetailList["id"],
          this.productDetailList["model"],
          this.imageUrl,
          "Top Navigation"
        );
      } catch (error) { }
    }
  }
  clevertapPayementcompFailed(amount) {
    if (isPlatformBrowser(this.platformId)) {

      try {
        this.cleverService.onPaymentCompleted(
          "Success",
          "Online Transfer",
          this.productDetailList["id"],
          this.productDetailList["model"],
          this.imageUrl,
          "Top Navigation",
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          amount * this.quantity,
        );
      } catch { }
    }
  }

  clevertapPayementFailed(amount) {

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPaymentfailed(
          this.productDetailList["id"],
          "Online Transfer",
          this.imageUrl,

          this.productDetailList["model"],
          "Top Navigation",
          this.productDetailList['sub_lob'],
          this.productDetailList['lob'],
          this.productDetailList['ppl'],
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          amount * this.quantity,
        );
      } catch { }
    }
  }
  productAddedtoCart() {

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onProductAddedtocart(
          this.productDetailList["id"],
          this.imageUrl,
          this.productDetailList["model"],
          this.productDetailList["sub_lob"],
          this.productDetailList["lob"],
          this.productDetailList["ppl"],
          this.productDetailList['price_range'] ? this.productDetailList['price_range'] : "",
          this.productDetailList['down_payment'],
          "",
          "",
          "",
          ""
        );
      } catch { }
    }

  }
  sanitizeInput(input: string): string {
    // Remove HTML tags
    return input.replace(/<\/?[^>]+(>|$)/g, '');
  }

  // Usage in the HTML
  onInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    inputElement.value = this.sanitizeInput(inputElement.value);
  }
  getPaymentData(data:any){
    let payload = {
     "action_type":"payment_data",
    "row_id":data
  }
  // this.spi.show();
  this.sub.add(this.apiService.getLeadsnew(payload).subscribe({
      next: (res) => {
        if (res.success) {
       this.payment_data = res?.data?.payment_data
        // this.spinner.hide();
        }
        else{
          this.payment_data = [];
          // this.toastrService.warning(res.data.msg);
          // this.spinner.hide();
        }
      },
      error: (err) => {
      },complete: () => { }
    }));
  }

  getLoyalitySignup() {
    const data = {
      mobile_number: this.userData?.mobile_number,
      first_name: this.userData?.first_name,
      last_name: this.userData?.last_name,
      email_id: this.userData?.email_id,
      created_source: "OSP",
      // user_type: "Customer",
      // user_tier: "Gold",
      // kyc: "Aadhar"
    };
    try {

      this.sub.add(
        this.apiService.signUpLoyality(data).subscribe({
          next: (res) => {
            if (res.success) {

            } else {
            }

          },
          error: (err) => {
          },
          complete: () => {
            this.spinner.hide();
          },
        })
      );
    } catch (error) {}
  }
  userAaccumulation(data: any) {
    try {
      this.sub.add(
        this.apiService.addUserAaccumulation(data).subscribe({
          next: (res) => {
            if (res.success) {

            } else {

            }

          },
          error: (err) => {

          },
          complete: () => {

          },
        })
      );
    } catch (error) {

    }
  }
  vastatrequestresponsereturn(data?): Promise<any> {
    return new Promise((resolve, reject) => {
      let id = localStorage.getItem('tat_id');
      let Payload = {
        "id": id ? id:'',
        "home_configurator_request":"",
        "home_configurator_response":"" ,
        "osp_configurator_vas_filter_request":'',
        "osp_configurator_vas_filter_response":'',
        "request_id": data,
        "vehicle_number":"",
        "model": "",
        "number_of_vehicles": "",
        "application": '',
        "terrain":'',
        "annual_runnig":'',
        "duration_of_amc":'',
        "vas_offer":'',
        "amc": "",
        "fms": "",
        "ew": "",
        "oss": "",
        "fleetedge": "",
        "uptime_guarantee": "",
        "source": "",
        "vas_booking_price":"",
      };

      // this.spinner.show();

      this.apiService.getvastat(Payload).subscribe({
        next: (res: any) => {
          // this.spinner.hide();
          if (res?.success) {
            resolve(res);
          } else {
            reject("API call failed.");
          }
        },
        error: (error: any) => {
          // this.spinner.hide();
          reject(error);
        },
        complete: () => {
          // this.spinner.hide();
        }
      });
    });
  }
  updateFirstNameValidation(accountType: string) {
    const firstNameControl = this.bookingForm.get('first_name');
    const lastNameControl = this.bookingForm.get('last_name');
    const full_nameControl = this.bookingForm.get('full_name');
    if (firstNameControl && lastNameControl) {
      if (accountType === 'Individual') {
        firstNameControl.setValidators([
          Validators.required,
          this.individualNameValidator
        ]);
        lastNameControl.setValidators([
          this.individualNameValidator
        ]);
        full_nameControl.setValidators([
        ]);
      } else if (accountType === 'Company') {
        full_nameControl.setValidators([
          Validators.required,
          this.companyNameValidator
        ]);
        lastNameControl.setValidators([
        ]);
        firstNameControl.setValidators([
   
        ]);
      }

      firstNameControl.updateValueAndValidity();
      lastNameControl.updateValueAndValidity();
      full_nameControl?.updateValueAndValidity();
      // this.bookingForm.get('pan_type')?.setValue(accountType); // Update form value
      this.bookingForm.get('panNo')?.updateValueAndValidity();
    }
  }

  // Validator for Individual Names (Only Alphabets and Spaces)
  individualNameValidator(control: AbstractControl) {
    const nameRegex = /^[A-Za-z\s]+$/; // Only letters and spaces
    return control.value && !nameRegex.test(control.value) ? { invalidIndividualName: true } : null;
  }

  // Validator for Company Names (Allow all except < > { } | ~ ^ *)
  companyNameValidator(control: AbstractControl) {
    const restrictedChars = /[<>{}|~^*]/; // Restricted special characters
    return control.value && restrictedChars.test(control.value) ? { invalidCompanyName: true } : null;
  }
  hasError(controlName: string, errorType: string) {
    return this.bookingForm.get(controlName)?.hasError(errorType); //&& this.bookingForm.get(controlName)?.touched;
  }
  companyNameError: boolean = false;

  validateCompanyName(event: any) {
    let inputValue = event.target.value;
    const restrictedChars = /[<>{}|~^*]/;
  
    if (restrictedChars.test(inputValue)) {
      this.companyNameError = true;
    } else {
      this.companyNameError = false;
    }
  
    inputValue = inputValue.replace(/[<>{}|~^*]/g, '');
    event.target.value = inputValue;
  
    this.bookingForm.controls['full_name'].setValue(inputValue, { emitEvent: false });
  }
  
  checkCompanyNameError() {
    const fieldValue = this.bookingForm.controls['full_name'].value;
    this.companyNameError = /[<>{}|~^*]/.test(fieldValue);
  }

  nameErrors: { [key: string]: boolean } = {
    first_name: false,
    last_name: false,
  };

validateName(event: any, fieldName: string) {
  let originalValue = event.target.value;

  // Check if the original value contains any disallowed characters
  const hasInvalidChars = /[^a-zA-Z\s]/.test(originalValue);
  this.nameErrors[fieldName] = hasInvalidChars;

  // Now clean the value
  const cleanedValue = originalValue.replace(/[^a-zA-Z\s]/g, '');

  // Update the input and the form control
  event.target.value = cleanedValue;
  this.bookingForm.controls[fieldName].setValue(cleanedValue, {
    emitEvent: false,
  });
}

  checkNameError(fieldName: string) {
    const fieldValue = this.bookingForm.controls[fieldName].value;
    this.nameErrors[fieldName] = /[^a-zA-Z\s]/.test(fieldValue);
  }
  hasPatterncheckError(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const panValue = control.value;
      if (!panValue) return null; // Allow empty value, no error
  
      if (panValue.length !== 10) return null; // Ignore if invalid length
  
      const panType = this.bookingForm?.get('pan_type')?.value; // Get selected PAN type
      const fourthChar = panValue.charAt(3); // Get the 4th character
  
      if (panType === 'Individual' && fourthChar !== 'P') {
        return { invalidPanForIndividual: true }; // Error for Individual
      }
      if (panType === 'Company' && fourthChar === 'P') {
        return { invalidPanForCompany: true }; // Error for Company
      }
  
      return null; // No errors
    };
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      this.modalService.dismissAll();
      // localStorage.removeItem("productOfferData")
    }
  }
  public hasRequiredError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasRequiredError(controlName, this.bookingForm);
  public hasPatternError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);
  public hasMaxLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);

  public hasMinLengthError = (controlName: string): boolean | undefined =>
    this.formErrorService.hasPatternError(controlName, this.bookingForm);

}

export class PaymentResponse {
  razorpay_payment_id: string = '';
  razorpay_order_id: string = '';
  razorpay_signature: string = '';
}
